import React, {Component} from 'react';
import BaseUrlConfig from '../../../../net/BaseUrlConfig';
import rdcAppImg from '../assets/rdc_app.png';
import horizonImg from '../assets/horizon_client.png';
import searchBarImg from '../assets/search_bar.png';
import searchResultImg from '../assets/search_result.png';
import rdcWindowImg from '../assets/rdc_window.png';
import credentialsErrorImg from '../assets/credentials_error.png';
import policiesFolderImg from '../assets/policies_folder.png';

class ManualsAndPoliciesDashboard extends Component {
    render() {
        const activeProfile = BaseUrlConfig.profile;
        let ip = '192.168.213.27';
        if (activeProfile === 'prodsh') {
            ip = '192.168.130.27';
        }
        if (activeProfile === 'prodsg' || activeProfile === 'prodhk') {
            ip = '192.168.213.27';
        }
        let contactName = 'Weiwei Jin';
        if (activeProfile === 'prodsh') {
            contactName = 'Xie Lei';
        }

        return (
            <div>
                <style>
                {`            
                    .ManualsAndPoliciesDashboarddWrapper {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        height: 100%;
                        width: 100%;
                        padding: 40px 50px;
                        font-size: 16px;
                        line-height: 1.5;
                        color: #000000;
                        font-family: Arial, sans-serif;
                    }
                    .ManualsAndPoliciesDashboarddWrapper .section-title {
                        font-size: 18px;
                        font-weight: bold;
                        text-decoration: underline;
                        margin-top: 15px;
                        margin-bottom: 20px;
                    }
                    .ManualsAndPoliciesDashboarddWrapper .step-item {
                        margin-bottom: 25px;
                    }
                    .ManualsAndPoliciesDashboarddWrapper .step-title {
                        margin-bottom: 12px;
                    }
                    .ManualsAndPoliciesDashboarddWrapper .step-img {
                        margin: 10px 0;
                        display: block;
                    }
                    .ManualsAndPoliciesDashboarddWrapper .sub-note {
                        font-style: italic;
                        margin-top: 8px;
                        color: #000000;
                    }
                `}
                </style>
                <div className='ManualsAndPoliciesDashboarddWrapper'>
                    <div style={{ marginBottom: '15px' }}>
                        To view the manuals and policies, please use the “<strong>Remote Desktop Connection</strong>” application.
                    </div>
                    <img src={rdcAppImg} alt="Remote Desktop Connection App" style={{ marginBottom: '25px' }} />

                    <div className="section-title">How to Access</div>

                    <div className="step-item">
                        <div className="step-title">
                            <strong>Step 1:</strong> Please open the Virtual Machine (“<strong>VM</strong>”) application and log in using your system ID and password.
                        </div>
                        <img src={horizonImg} alt="Omnissa Horizon Client" className="step-img" />
                        <div className="sub-note">
                            For VM installation and setup assistance, please contact the <strong>IT Team</strong>.
                        </div>
                    </div>

                    <div className="step-item">
                        <div className="step-title">
                            <strong>Step 2:</strong> Search for “<strong>Remote Desktop Connection</strong>” in the Windows Search Bar and open the application.
                        </div>
                        <img src={searchBarImg} alt="Windows Search Bar" className="step-img" style={{ marginBottom: '12px' }} />
                        <img src={searchResultImg} alt="Remote Desktop Connection Search Result" className="step-img" />
                    </div>

                    <div className="step-item">
                        <div className="step-title">
                            <strong>Step 3:</strong> Enter the following address in the Computer field: “<strong>{ip}</strong>” and click “<strong>Connect</strong>”.
                        </div>
                        <img src={rdcWindowImg} alt="Remote Desktop Connection Window" className="step-img" />
                    </div>

                    <div className="step-item">
                        <div className="step-title">
                            <strong>Step 4:</strong> The User ID will default to your login ID. Please enter your system password.
                        </div>
                        <img src={credentialsErrorImg} alt="Windows Security Credentials" className="step-img" />
                    </div>

                    <div className="step-item">
                        <div className="step-title">
                            <strong>Step 5:</strong> Double-click the “<strong>Policies</strong>” folder on the desktop and select the relevant office to view the details.
                        </div>
                        <img src={policiesFolderImg} alt="Policies Folder Desktop Shortcut" className="step-img" />
                    </div>

                    <div className="section-title" style={{ marginTop: '20px' }}>Support</div>
                    <div>
                        For password enquiries, VM installation, or access issues, please contact the <strong>IT Team: {contactName}</strong>.
                    </div>
                </div>
            </div>
        );
    };
}

export default ManualsAndPoliciesDashboard;


